import { demoPresets, initialCabinState } from "./demoPresets";
import type { ParcelPickupPoint } from "./amapParcelDemo";

export type ParcelShowcaseStage = "reminder" | "route" | "toPickup" | "arrivedPickup" | "toHome" | "homeReminder" | "acknowledged";

// A separate, fixed home keeps the presentation route stable across devices.
export const PARCEL_SHOWCASE_HOME = { lng: 121.49188, lat: 31.24062 };

export function createParcelShowcaseState() {
  const preset = demoPresets.find((item) => item.id === "weekday-parcel");
  return { ...initialCabinState, ...preset?.statePatch, desktop: "standard" as const };
}

export function withParcelShowcaseTime(point: ParcelPickupPoint): ParcelPickupPoint {
  const minutes = 18 * 60 + 30 + point.routeMinutes;
  return {
    ...point,
    eta: `${String(Math.floor(minutes / 60) % 24).padStart(2, "0")}:${String(minutes % 60).padStart(2, "0")}`
  };
}
